import React from 'react';
import SuccessCases from '../../components/SuccessCases';
import { CheckCircle2 } from 'lucide-react';

const ProjectsPage: React.FC = () => {
  return (
    <div className="pt-10">
      
      <SuccessCases />

      {/* Methodology Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            
            {/* Left Side: Methodology Steps */}
            <div className="space-y-8 animate-slide-left">
                <div>
                    <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-3 tracking-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.1)]">
                        Metodología de <span className="text-mira-accent">Implementación</span>
                    </h3>
                    <p className="text-gray-400 text-lg leading-relaxed font-medium">
                        Nuestro proceso garantiza automatizaciones estables, claras y hechas para funcionar desde el día uno.
                    </p>
                </div>
                
                <div className="space-y-8">
                    {/* Step 1 */}
                    <div className="flex gap-5">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-mira-surface border border-mira-border flex items-center justify-center text-mira-accent font-bold text-lg shadow-[0_0_15px_rgba(26,140,255,0.2)]">1</div>
                        <div>
                            <h4 className="text-white font-bold text-xl mb-1">Diagnóstico</h4>
                            <p className="text-gray-400">Revisamos cómo operas y qué tareas se pueden automatizar.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="flex gap-5">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-mira-surface border border-mira-border flex items-center justify-center text-mira-accent font-bold text-lg shadow-[0_0_15px_rgba(26,140,255,0.2)]">2</div>
                        <div>
                            <h4 className="text-white font-bold text-xl mb-1">Diseño del flujo</h4>
                            <p className="text-gray-400">Creamos el sistema exacto que tu negocio necesita.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="flex gap-5">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-mira-surface border border-mira-border flex items-center justify-center text-mira-accent font-bold text-lg shadow-[0_0_15px_rgba(26,140,255,0.2)]">3</div>
                        <div>
                            <h4 className="text-white font-bold text-xl mb-1">Integración</h4>
                            <p className="text-gray-400">Conectamos WhatsApp, Calendar y tus herramientas actuales.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="flex gap-5">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-mira-surface border border-mira-border flex items-center justify-center text-mira-accent font-bold text-lg shadow-[0_0_15px_rgba(26,140,255,0.2)]">4</div>
                        <div>
                            <h4 className="text-white font-bold text-xl mb-1">Pruebas</h4>
                            <p className="text-gray-400">Validamos cada paso antes de activar la automatización.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side: Results Panel */}
            <div className="lg:mt-8 animate-fade-up">
                <div className="bg-mira-surface border border-mira-border rounded-2xl p-8 relative overflow-hidden group hover:border-mira-accent/40 transition-all duration-300 shadow-2xl">
                    <div className="absolute inset-0 bg-gradient-to-br from-mira-accent/10 to-transparent opacity-60"></div>
                    
                    <div className="relative z-10">
                        <div className="flex items-center gap-3 mb-8">
                            <span className="text-2xl drop-shadow-[0_0_10px_rgba(255,255,0,0.5)]">⭐</span>
                            <h3 className="text-2xl font-extrabold text-white tracking-wide">Resultados Reales</h3>
                        </div>

                        <ul className="space-y-4">
                            <li className="flex items-center justify-between p-4 bg-mira-bg/60 rounded-xl border border-mira-border backdrop-blur-sm hover:bg-mira-bg/80 transition-colors">
                                <span className="text-white font-bold">Más Citas</span>
                                <span className="text-xl font-extrabold text-green-400 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]">+62%</span>
                            </li>
                            <li className="flex items-center justify-between p-4 bg-mira-bg/60 rounded-xl border border-mira-border backdrop-blur-sm hover:bg-mira-bg/80 transition-colors">
                                <span className="text-white font-bold">Cancelaciones</span>
                                <span className="text-xl font-extrabold text-red-400 drop-shadow-[0_0_5px_rgba(248,113,113,0.5)]">-80%</span>
                            </li>
                            <li className="flex items-center justify-between p-4 bg-mira-bg/60 rounded-xl border border-mira-border backdrop-blur-sm hover:bg-mira-bg/80 transition-colors">
                                <span className="text-white font-bold">Atención</span>
                                <span className="text-xl font-extrabold text-mira-accent drop-shadow-[0_0_5px_rgba(26,140,255,0.5)]">24/7</span>
                            </li>
                            <li className="flex items-center justify-between p-4 bg-mira-bg/60 rounded-xl border border-mira-border backdrop-blur-sm hover:bg-mira-bg/80 transition-colors">
                                <span className="text-white font-bold">Flujos</span>
                                <span className="text-xl font-extrabold text-blue-200 drop-shadow-[0_0_5px_rgba(191,219,254,0.5)]">100% Auto</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;